import { createTransform } from 'redux-persist';
import CryptoJS from 'crypto-js';
import { RootState } from './hook';

const setTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState: RootState) => {
    const encryptedData: string = CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      process.env.REACT_APP_REDUX_ENCRYPTION_SECRET || '',
    ).toString();
    return encryptedData;
  },
  // transform state being rehydrated
  (outboundState: string) => {
    const decryptedData: string = CryptoJS.AES.decrypt(
      outboundState,
      process.env.REACT_APP_REDUX_ENCRYPTION_SECRET || '',
    ).toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedData);
  },
);

export default setTransform;
